import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Text } from 'react-orange-ui';
import { ArrowLink } from 'react-onei';

import WordingService from '../../../services/WordingService';
import TagService from '../../../services/TagService';
import Space from '../../../orange-ui/components/Spaces/Space';

class MultibalCannotUseContact extends Component {
    render() {
        const { redirectUrl } = this.props;

        return (
            <div>
                <Text as="h3" bold size="m" id="mbal-cannot-use-contact-label">
                    {WordingService.getWording('caption', 'multibalCannotUseContactTitle')}
                </Text>
                <Space size="s" />
                <Text size="s" id="mbal-cannot-use-contact-indication">
                    {WordingService.getWording('caption', 'multibalCannotUseContactInfo')}
                </Text>
                <Space size="m" />
                <ArrowLink
                    href={redirectUrl}
                    id="mbal-cannot-use-contact"
                    onClick={() => TagService.sendAction('multibalCannotUseContact')}
                    aria-label="Retour"
                    title="Retour"
                    variant="previous"
                >
                    {WordingService.getWording('button', 'back')}
                </ArrowLink>
                <Space size="l" />
            </div>
        );
    }
}

MultibalCannotUseContact.propTypes = {
    redirectUrl: PropTypes.string.isRequired,
};

export default MultibalCannotUseContact;